<template>
	<div class='forecast'>
		<div class='grid select-value-block'>
			<div :class='{ "not-match": !isMatch(values["forecast_s_weakening"]) }'>
				<span class='select-title'>Ослабление лесных насаждений, га</span>
				<custom-p-input v-model='values["forecast_s_weakening"].value' type='number' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["forecast_s_shrinking"]) }'>
				<span class='select-title'>Усыхание лесных насаждений, га	</span>
				<custom-p-input v-model='values["forecast_s_shrinking"].value' type='number' :disabled='!actLpoIsDraft'/>
			</div>

			<div :class='{ "not-match": !isMatch(values["forecast_s_pests"]) }'>
				<span class='select-title'>Развитие очагов вредных организмов, га</span>
				<custom-p-input v-model='values["forecast_s_pests"].value' type='number' :disabled='!actLpoIsDraft'/>
			</div>

		</div>

		<div class='values-btn-row not-match-block' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'InspectionForecast',
		data() {
			return {
				values: {
					forecast_s_weakening: {
						field: 'forecast_s_weakening',
						inputType: 'input',
						value: null
					},
					forecast_s_shrinking: {
						field: 'forecast_s_shrinking',
						inputType: 'input',
						value: null
					},
					forecast_s_pests: {
						field: 'forecast_s_pests',
						inputType: 'input',
						value: null
					}
				}

			};
		},
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},

			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},
		},
		methods: {
			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const temp = {
						field: this.values[value_name].field,
						value: inputTypeIsSelect ? this.values[value_name].value.id : this.values[value_name].value
					};
					valueList.push(temp);
				}

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},

			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.sLpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},

			isMatch(value) {

				if (value.inputType === 'input') {
					return value.value === this.lpo[value.field];
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			this.resetValues();
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/input.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}
</style>